import React from 'react';
import { LinkIcon } from '@heroicons/react/24/outline';
import { RankingEntity } from './SortableEntity';

interface TieConnectorProps {
  entityAbove: RankingEntity;
  entityBelow: RankingEntity;
  onCreateTie: (entityId1: string, entityId2: string) => void;
  onSeparateFromTie: (entityId: string) => void;
  isDragging: boolean;
}

const TieConnector: React.FC<TieConnectorProps> = ({
  entityAbove,
  entityBelow,
  onCreateTie,
  onSeparateFromTie,
  isDragging,
}) => {
  const isTied = entityAbove.tiedWith.includes(entityBelow.id);

  const handleClick = () => {
    if (isTied) {
      onSeparateFromTie(entityBelow.id);
    } else {
      onCreateTie(entityAbove.id, entityBelow.id);
    }
  };

  return (
    <div
      className={`h-0 relative flex items-center justify-center py-1 ${
        isDragging ? 'pointer-events-none' : ''
      }`}
    >
      {/* Line */}
      <div
        className={`absolute inset-x-8 top-1/2 -translate-y-1/2 h-px ${
          isTied ? 'bg-warning-400' : 'border-t border-dashed border-stone-300'
        }`}
      />
      {/* Button */}
      <button
        type="button"
        onClick={handleClick}
        className={`relative z-10 flex items-center justify-center min-w-[48px] min-h-[48px] rounded-full transition-colors ${
          isTied
            ? 'bg-warning-50 text-warning-500 hover:bg-warning-100'
            : 'bg-surface text-stone-300 hover:text-primary-400 hover:bg-primary-50'
        }`}
        aria-label={isTied ? 'Remove tie' : 'Create tie'}
      >
        <LinkIcon className="w-5 h-5" />
      </button>
    </div>
  );
};

export default TieConnector;
